import { render } from "./CustomFileLoader.vue?vue&type=template&id=7bb5b884&scoped=true"
import script from "./CustomFileLoader.vue?vue&type=script&lang=js"
export * from "./CustomFileLoader.vue?vue&type=script&lang=js"

import "./CustomFileLoader.vue?vue&type=style&index=0&id=7bb5b884&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb5b884"]])

export default __exports__